import { render } from "./agentSuccess.vue?vue&type=template&id=dc4aba94&scoped=true"
const script = {}

import "./agentSuccess.vue?vue&type=style&index=0&id=dc4aba94&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4aba94"]])

export default __exports__